import styled from '@emotion/styled';
import { Spacings } from '@styles/index';

const BlockWrapper = styled.div`
  grid-column: span 18;
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  grid-gap: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_14B};
`;

export default BlockWrapper;
